<template>
  <div class="skeleton" :class="imageTop ? 'topImage rounded-top' : ''" :style="!imageTop ? customStyle : ''"></div>
</template>
<script>
export default {
  name: "SkeletonLoader",
  props: {
    imageTop: {
        type: Boolean,
        default: false
    },
    height: {
        type: String,
        default: '26px'
    },
    width: {
        type: String,
        default: '100%'
    },
    cornerRadius: {
        type: String,
        default: '13px'
    },
  },
  computed:{
    customStyle() {
        const stl = `height: ${this.height}; width: ${this.width};border-radius: ${this.cornerRadius};`
        return stl;
    }
  }
};
</script>
<style scoped>
.skeleton {
  animation: loading 1s infinite;
  cursor: progress;
  background: linear-gradient(0.25turn, transparent, #fff, transparent),
    linear-gradient(#eee, #eee),
    radial-gradient(38px circle at 19px 19px, #eee 50%, transparent 51%),
    linear-gradient(#eee, #eee);
  background-repeat: no-repeat;
  background-position: -315px 0, 0 0, 0px 190px, 57px 195px;
}
.topImage {
  width: 100%;
  height: 57px;
  border: 1px solid rgb(215, 215, 215);
  border-bottom: none;
}

@keyframes loading {
  to {
    background-position: 315px 0, 0 0, 0 190px, 57px 195px;
  }
}
</style>
